import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommunityAvatarUrlPipe } from '../../pipes/community-avatar-url.pipe';

/** Anything that carries an avatar and a name to fall back on. */
export interface AvatarLike {
  avatar_url?: string | null;
  first_name?: string | null;
  full_name?: string | null;
  username?: string | null;
  display_name?: string | null;
}

/**
 * A member's avatar, or their initial on a neutral disc when they have none.
 * Purely presentational, so it can sit inside links and buttons.
 */
@Component({
  selector: 'app-community-avatar',
  standalone: true,
  imports: [CommunityAvatarUrlPipe],
  template: `
    @if (user?.avatar_url) {
      <img class="community-avatar" [style.width.px]="size" [style.height.px]="size"
           [src]="user!.avatar_url | communityAvatarUrl" alt="" loading="lazy" />
    } @else {
      <span class="community-avatar community-avatar--placeholder"
            [style.width.px]="size" [style.height.px]="size" [style.font-size.px]="size * 0.45" aria-hidden="true">{{ initial }}</span>
    }
  `,
  styles: [`
    :host { display: inline-block; line-height: 0; vertical-align: middle; }
    .community-avatar {
      border-radius: 50%;
      object-fit: cover;
      background: var(--cui-secondary-bg, #eee);
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-weight: 600;
      text-transform: uppercase;
      line-height: 1;
      &.community-avatar--placeholder { color: var(--cui-body-color, #333); }
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommunityAvatarComponent {
  @Input() user: AvatarLike | null | undefined;
  /** Pixel size (width = height). */
  @Input() size = 32;

  get initial(): string {
    const u = this.user;
    const name = u?.first_name || u?.full_name || u?.display_name || u?.username || '?';
    return name.trim().charAt(0) || '?';
  }
}
